// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../header/HeaderComponent";
import Footer from "../footer/FooterComponent";
import NewsletterFormComponent from "../NewsletterForm/NewsletterFormComponent";
import Seo from "../Seo/SeoComponent";
import styles from "../../styles/authForm.module.scss";

function NewsletterPage() {
    const { t, i18n } = useTranslation("newsletterPage");
    const isPt = i18n.language === "pt";
    const currentPath = isPt ? "/pt/newsletter" : "/newsletter";

    return (
        <div className={styles.page}>
            <Seo
                title={t("seoTitle")}
                description={t("seoDescription")}
                path={currentPath}
                lang={isPt ? "pt-PT" : undefined}
            />
            <Header />

            <main className={styles.main}>
                <div className={styles.container}>
                    <div className={styles.card}>
                        <h1 className={styles.title}>{t("title")}</h1>
                        <p className={styles.subtitle}>
                            {t("subtitle")}
                        </p>

                        <NewsletterFormComponent />
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default NewsletterPage;
